module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUVJREFUOE+tkz9LA0EQxd/bi6iNQdHOIp1VvAQrKyEgSfwUNiZiFyvhGhEP7FL57/wgpwgBKys1wUa7FIKFIRIbFbwdyYZAPMMFTrdY2J2ZHzNvZojQyR7k7SCwSgRygKR6ZjYFqFlW4N3tXDQGQ9h/pHbXJ6bGnqsASwRVGNx9C0QD4rVbb9tP1et3g+5e85XlyZm5pE/hyrDA8J9QrtovnWIXYgBpt3CiwHLYseH4xm67RQnbNOT03jnfZHYvbwcJdUvBr7SjAEJoJV9LXHTXDgnZGpZ6FKCnCY+Y3i88KHIhDkCLPNJ2ix8AxuMAAHz+HRBVwqiWmhKiRBwFEOhjZtzVjGbiJnYb4w4SAK/h+OX/GeX+PkzPJqskN4aVYwaH0CJy9trqVH4s06BYRhPNklDlFGnWWYs0SakpaK/uXNYH/b8BqMCoEyCI9r4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tipG.png
// module id = 33
// module chunks = 0